import React from "react";
import "./i18n";
import { GlobalStyle } from "./styles/GlobalStyles";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Services } from "./components/Services";
import { About } from "./components/About";
import { Testimonials } from "./components/Testimonials";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { FaWhatsapp as FaWhatsappIcon } from "react-icons/fa";
import styled from "styled-components";

const WhatsApp = FaWhatsappIcon as unknown as React.FC<{ size?: number }>;

const WhatsAppButton = styled.a`
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: #25d366;
  color: white;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  z-index: 1000;
`;

const App: React.FC = () => (
    <>
            <GlobalStyle />
            <Navbar />
            <Hero />
            <Services />
            <About />
            <Testimonials />
            <Contact />
            <Footer />
            <WhatsAppButton
                href="https://wa.me/5491153224748"
                target="_blank"
                rel="noopener noreferrer"
            >
                <WhatsApp size={32} />
            </WhatsAppButton>
    </>
);

export default App;
